export default "__VITE_ASSET__BOuG77$J__"